import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ChannelCodeType } from '@/models/reservation-channel-code'

type Props = {
  channelCodes: ChannelCodeType[]
}

export const SettingChannelCodeList: React.FC<Props> = ({ channelCodes }) => {
  const { t } = useTranslation()

  return (
    <>
      <div css={paymentListHeaderStyle}>
        <div css={channelCodeWidthStyle}>{t('Channel code')}</div>
        <div css={nameWidthStyle}>{t('Name')}</div>
        <div css={nameWidthStyle}>{t('Segment')}</div>
      </div>

      <ul
        css={paymentListStyle}
        style={{
          // 55px(header), 24px(padding), 45px(tab), 75px(toolbar), 32px(th)
          height: window.innerHeight - 55 - 24 * 2 - 45 - 75 - 32,
          overflowY: 'auto',
        }}
      >
        {channelCodes.map((channelCode: ChannelCodeType, index) => (
          <li key={index}>
            <div css={channelCodeWidthStyle}>{channelCode.code || '-'}</div>
            <div css={nameWidthStyle}>{channelCode.name}</div>
            <div css={nameWidthStyle}>{channelCode.suggestSegmentName || '-'}</div>
          </li>
        ))}
      </ul>
    </>
  )
}

const paymentListHeaderStyle = css({
  background: '#F5F5F5',
  color: '#676767',
  display: 'flex',
  fontSize: 12,
  fontWeight: 'bold',
  padding: '10px 43px 10px 28px',
})

const paymentListStyle = css({
  li: {
    display: 'flex',
    padding: '16px 32px',
    color: '#272727',
    fontSize: 14,
    borderBottom: '1px #F2F2F2 solid',
  },
})

const channelCodeWidthStyle = css({
  width: '15%',
  paddingLeft: 2,
})

const nameWidthStyle = css({
  flex: 1,
  paddingLeft: 2,
})
